import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  faFilePdf,
  faTimes,
  faTrash,
  faTrashAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { TranslateModule } from "@ngx-translate/core";
import { DndDirective } from "src/app/directives/dnd.directive";
import { FileToUpload } from "src/app/models/FileToUpload";

// Maximum allowed file size to upload = 10MB
const MAX_SIZE_IN_BYTES: number = 10485760;
const ALLOWED_FILE_TYPES = ["application/pdf"];

@Component({
  selector: "drag-n-drop",
  templateUrl: "./drag-n-drop.component.html",
  styleUrls: ["./drag-n-drop.component.scss"],
  imports: [TranslateModule, FontAwesomeModule, DndDirective, CommonModule],
  standalone: true,
})
export class DragNDropComponent {
  faUpload = faUpload;
  faTrashAlt = faTrashAlt;
  faFilePdf = faFilePdf;
  faTimes = faTimes;
  faTrash = faTrash;

  fileToUpload?: File = null;

  allowedFileTypes = ALLOWED_FILE_TYPES;

  @Output() file: EventEmitter<FileToUpload> = new EventEmitter<FileToUpload>();

  onFileListChange(files: FileList) {
    if (!files?.length) {
      this.file.emit(null);
      return;
    }
    // TODO: add remove button (removes already selected file)
    const file = files[0];
    if (!ALLOWED_FILE_TYPES.some((x) => x === file.type)) {
      alert(
        `Not supported file extension. Supported extensions are: ${ALLOWED_FILE_TYPES.join(", ")}.`,
      );
    } else if (file.size > MAX_SIZE_IN_BYTES) {
      alert("File: " + file.name + " is too large to upload. Max allowed size is 10MB.");
    } else {
      this.fileToUpload = file;
      this.readFile(file);
    }
  }

  onFilesDrop(fileList: FileList) {
    this.onFileListChange(fileList);
  }

  onFileInput(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    this.onFileListChange(files);
  }

  private readFile(file: File) {
    const fileToUpload = new FileToUpload();
    // // Set File Information
    fileToUpload.fileName = file.name;
    fileToUpload.fileSize = file.size;
    fileToUpload.fileType = file.type;
    fileToUpload.lastModifiedTime = file.lastModified;
    fileToUpload.lastModifiedDate = new Date(file.lastModified);
    fileToUpload.fileUpload = file;
    this.file.emit(fileToUpload);
  }
}
